(function(){
    'use strict'; 
    angular.module("Directives").directive("bbaAccountingNotifPanel", bbaAccountingNotifPanel); 
    bbaAccountingNotifPanel.$inject = [
        "AccountingService",
        "$uibModal",
        "toastr",
        "$q"
    ]; 

    function bbaAccountingNotifPanel(
        AccountingService,
        $uibModal,
        toastr,
        $q
    ){
        return {
            restrict: "E", 
            templateUrl: "/templates/directives/components/accounting/bbaAccountingNotifPanel.html", 
            scope: {
                notifShipment: '=', 
                updateTableCallback: '=',
                invoiceData: '=',
                options: '='
            }, 
            link: bbaAccountingNotifPanelLink
        }
        function bbaAccountingNotifPanelLink($scope, $elms, $attrs) {
            $scope.notifyCustomer = notifyCustomer;
            $scope.viewNotif = viewNotif;
            $scope.issueCreditNote = issueCreditNote;
            $scope.createCase = createCase; 

            init();
            
            function init(){
                $scope.$watch('notifShipment', data => {
                    getShipmentCases().then(data => {
                        if(data.length > 0) {
                            const notResolvedCases = data.filter(caseData => {
                                return !caseData.resolved;
                            });
                            $scope.showMakeCorrectionAndCreateCaseButton = false;
                            $scope.showIssueCreditNoteButton = notResolvedCases.length > 0 ? false : true; 
                            $scope.showCaseNotResolveWarning = notResolvedCases.length > 0 ? true : false;
                            $scope.casesTobeResolved = notResolvedCases;
                            $scope.allCases = data;
                        }
                        else {
                            $scope.showIssueCreditNoteButton = false; 
                            $scope.showMakeCorrectionAndCreateCaseButton = true;
                        }
                    });
                });
            }

            function getShipmentCases(){
                const deffered = $q.defer(); 
                AccountingService.CaseManagement.getAll(success => {
                    deffered.resolve(success.content);
                }, error => {
                    toastr.error(error.message, "Error"); 
                }, {'shipmentId' : $scope.notifShipment.id});
                return deffered.promise; 
            }

            function notifyCustomer(){
                $scope.sendingNotification = true; 
                AccountingService.HistoricalBilling.notifyCustomer(() => {
                    toastr.success("Notification Message Sent", "SUCCESS"); 
                    $scope.sendingNotification = false;
                }, error => {
                    toastr.info(error.message, "ERROR");
                    $scope.sendingNotification = false;
                }, $scope.invoiceData.id, $scope.notifShipment.id);
            }

            function viewNotif(){
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/accounting/historical-billing-notif-modal.html',
                    controller: 'AccountingHistoricalBillingNotifModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        shipment: () => $scope.notifShipment, 
                        invoiceId: () => $scope.invoiceId,
                        invoiceData: () => $scope.invoiceData
                    }
                });

                modalInstance.result.then((data) => {
                    if(data){
                        $scope.updateTableCallback(data);
                    }
                });
            }

            function issueCreditNote(){
                const modalInstance = $uibModal.open({
                    animation: true, 
                    ariaLabelledBy: 'modal-title', 
                    ariaDescribedBy: 'modal-body', 
                    windowClass: 'setting-modal issueCreditNoteModal', 
                    templateUrl: '/templates/pages/accounting/modals/issue-credit-note-modal.html', 
                    controller: 'IssueCreditNoteModalController', 
                    controllerAs: 'vm', 
                    size: 'lg', 
                    appendTo: $('body'),
                    resolve: {
                        shipment: () => $scope.notifShipment
                    }
                });
            }

            function createCase(){
                const createCaseModalInstance = $uibModal.open({
                    animation: true, 
                    ariaLabelledBy: 'modal-title', 
                    ariaDescribedBy: 'modal-body', 
                    windowClass: 'setting-modal issueCreditNoteModal', 
                    templateUrl: '/templates/pages/accounting/modals/create-case-modal.html', 
                    controller: 'CreateCaseModalController', 
                    controllerAs: 'vm', 
                    size: 'md', 
                    appendTo: $('body'),
                    resolve: {
                        shipment: () => $scope.notifShipment,
                        cases: () => $scope.allCases
                    }
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/accounting/bbaAccountingNotifPanel.js